// extracted by mini-css-extract-plugin
module.exports = {"productRegistrationPage":"ProductRegistration_productRegistrationPage__1p4op","tabAcceptance":"ProductRegistration_tabAcceptance__1S61H"};